// @flow
import { defaultPageProps } from '../../../../app/browser/analyticsDefaultProperties';

export default {
  page: {
    name: 'SP : Business List',
    properties: {
      ...defaultPageProps,
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/businessListAnalytics.js